/**
 * Canonical hash routes — IDENTICAL to the legacy app's constants/Routes.js
 * so every URL that exists in the wild keeps working unchanged:
 *
 *   - SAP's quote-approval email links customers to `#/screen/payment`
 *     (server-side template, outside our control)
 *   - customer bookmarks / browser history from years of the legacy app
 *
 * Legacy page → rebuild page mapping (the rebuild merged steps):
 *   /                       intro + address  (legacy: ScreenHomePage intro;
 *                           /screen/calculator was the address page — both
 *                           live inside ScreenHome now)
 *   /screen/overview        Select screens   (legacy: item list; the rebuild
 *                           folded the configurator into it)
 *   /screen/edit/...        single-line configurator deep-link
 *   /screen/summary         review
 *   /screen/submit          details + save
 *   /screen/payment         pay by RefNo + surname  ← EMAIL LINK TARGET
 */
export const ROUTE_HOME = '/'
export const ROUTE_SELECT_SCREENS = '/screen/overview'
export const ROUTE_EDIT = '/screen/edit'
export const ROUTE_SUMMARY = '/screen/summary'
export const ROUTE_SUBMIT = '/screen/submit'
export const ROUTE_PAYMENT = '/screen/payment'
